export let ProductExperience;

(function (ProductExperience) {
  ProductExperience["yes"] = "yes";
  ProductExperience["no"] = "no";
})(ProductExperience || (ProductExperience = {}));

export let ProblemAwareness;

(function (ProblemAwareness) {
  ProblemAwareness["yes"] = "yes";
  ProblemAwareness["no"] = "no";
})(ProblemAwareness || (ProblemAwareness = {}));